// extracted by mini-css-extract-plugin
export default {"shadowed":"About_shadowed__8BJwu","pink":"About_pink__jviH3","green":"About_green__T-hak","skills":"About_skills__tQCkM"};